import { useCallback } from "react"

export interface WebShareData {
  title?: string
  text?: string
  url?: string
  files?: File[]
}

export function useWebShare() {
  const isSupported =
    typeof navigator !== "undefined" &&
    "share" in navigator &&
    typeof navigator.share === "function"

  const share = useCallback(
    async (data: WebShareData): Promise<void> => {
      if (!isSupported) {
        throw new Error("Web Share API is not supported in this browser")
      }
      try {
        await navigator.share(data)
      } catch (error) {
        if (error instanceof Error && error.name !== "AbortError") {
          throw error
        }
      }
    },
    [isSupported],
  )

  return { share, isSupported }
}
